import { gql, useQuery } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { SUGGESTED_BENEFITS_ENROLLMENT_FRAGMENT } from "../pages/TabBenefits/gql/fragments"
import { Query } from "@oysterhr/schema"

export const BENEFITS_STAFF_EMPLOYMENT_ENROLLED_PACKAGES_QUERY = gql`
  ${SUGGESTED_BENEFITS_ENROLLMENT_FRAGMENT}
  query EmploymentChangePackage($engagementId: ID!, $useSalaryCurrencyCode: Boolean) {
    employment(employmentId: $engagementId) {
      salaryCurrencyCode
      countryCode
      company {
        id
      }
    }
    engagement(engagementId: $engagementId) {
      id
      engagementType
      benefitsProvisionedAddons {
        collection {
          id
        }
      }
      teamMember {
        name
      }
      benefitsEnrolledPackages {
        collection {
          id
          tier {
            id
            name
            fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
              currencyCode
              formatted
              subunit
              subunitToUnit
            }
          }
          enrollments {
            collection {
              ...SuggestedBenefitsEnrollmentFragment
            }
          }
        }
      }
    }
  }
`

interface QueryInput {
  engagementId: string
  useSalaryCurrencyCode: boolean
}

export const useEmploymentEnrolledPackages = (
  options: InjectedOptions<Pick<Query, "engagement" | "employment">, QueryInput>,
) => {
  const { data, ...rest } = useQuery(BENEFITS_STAFF_EMPLOYMENT_ENROLLED_PACKAGES_QUERY, {
    ...options,
    fetchPolicy: "cache-and-network",
  })

  return {
    ...rest,
    engagement: data?.engagement,
    employment: data?.employment,
  }
}
